import { defaultMetaTitle, defaultMetaDescription } from '../constants';

// Strip off redundant "Virgin Experience Days" post titles
// e.g. Blog Meta Title: London's Best Immersive Bars | Virgin Experience Days
export const stripVedPostTitle = (str) =>
  str ? str.replace(/ [-|] Virgin Experience( Days)?$/, '').trim() : '';

// Append "- Virgin Experience Days" in titles
export const getMetaTitle = (title: string, postTitleOverride?: string) => {
  if (!title) return null;
  const postTitle = postTitleOverride || 'Virgin Experience Days';
  return `${stripVedPostTitle(title)} - ${postTitle}`;
};

const hasNoIndex = (str) => {
  const pattern = /noindex/i;
  return pattern.test(str || '');
};

export const getPageMetaData = ({
  meta_title = '',
  meta_description = '',
  og_title = '',
  og_description = '',
  og_image = { url: '', alt: '', dimensions: { height: 0, width: 0 } },
  legacy_og_image = '',
  robots_controls = '',
  canonical = '',
  metaTitleSuffixed = false,
  ogTitleSuffixed = false,
}: {
  meta_title?: string;
  meta_description?: string;
  og_title?: string;
  og_description?: string;
  og_image?: any;
  legacy_og_image?: any;
  robots_controls?: string;
  canonical?: string;
  metaTitleSuffixed?: boolean;
  ogTitleSuffixed?: boolean;
}) => {
  // add ved post title only when not default meta title
  const _metaTitle = metaTitleSuffixed ? getMetaTitle(meta_title) : meta_title;
  const metaTitle = _metaTitle || defaultMetaTitle;

  const _ogTitle = og_title || metaTitle;
  const ogTitle =
    ogTitleSuffixed && _ogTitle !== defaultMetaTitle ? getMetaTitle(_ogTitle) : _ogTitle;

  const metaDescription = meta_description || defaultMetaDescription;
  const ogDescription = og_description || metaDescription;

  const result = {
    meta_title: metaTitle,
    meta_description: metaDescription,
    og_title: ogTitle,
    og_description: ogDescription,
    og_image,
    legacy_og_image,
    meta_robots: robots_controls,
    // no canonical when "noindex" is present in meta robots
    canonical: hasNoIndex(robots_controls) ? null : canonical,
  };

  return result;
};
